import React from "react";
import { getFitmentData } from "./fetcher";
import {ACTIONS} from "./reducer";

const options = [
    { label: 'Commercial Mower', value: 'Commercial Mower', },
    { label: '', value: 'None', },
]

export default function CategorySelect(props) { 
    const {state, dispatch} = props

    React.useEffect(() => {
        async function getManufacturers() {
            //will return an manufacturer list
            const labels = await getFitmentData({calltype: 2, equipmentCategory: state.category})
            dispatch({type: ACTIONS.SET_MANUFACTURERS, payload: labels})
        }

        getManufacturers()
    }, [dispatch, state.category])
    
    return (
        <>
            <select id="sel_equipmentCategory" required readOnly value={state.category}>
                {options.map((option, index) => (
                    <option key={`Category-${index}`} value={option.value}>{option.label}</option>
                ))}
            </select>
            <label htmlFor="sel_equipmentCateogry">Category:</label>
        </>
    )
}

